import * as feathers from 'feathers/client';
import * as hooks from 'feathers-hooks';
import registerServices from './services';
// import * as socketio from 'feathers-socketio/client';
// import * as io from 'socket.io-client';
import * as authentication from 'feathers-authentication-client';

// const socket = io('http://localhost:3030');

const app = feathers();

app
  // .configure(socketio(socket))
  .configure(hooks())
  .configure(authentication({
    storage: window.localStorage
  })
  );

registerServices(app);

export default app;


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/apps/BCOMS/client.ts